import * as React from 'react';
import { useTryInStoreStorage } from '../hooks/use-try-in-store-storage.js';
import { TryInStoreContext } from './context.js';

// Expose tryInStoreStorage via React Context
const TryInStoreProvider = ({ children  })=>{
    const storageValues = useTryInStoreStorage();
    return /*#__PURE__*/ React.createElement(TryInStoreContext.Provider, {
        value: storageValues
    }, children);
};

export { TryInStoreProvider };
//# sourceMappingURL=provider.js.map
